/* Night Notes (4 Nov 2026): the behaviour of sections/lv-night-notes.liquid. No libraries. Every block guards itself.
   1. the page dims: white light to the theme's night, the criteria dots light up red; reading progress
   2. the light switch (same states as lv.js section 3, with its own small loop because lv-focus does not load lv.js)
   3. the touch arc: a canvas light that comes from the lamp in the picture (falloff, warm red bloom, the room darker at the low end)
   4. the offer: picture tiles and rows choose the tier, the button follows (product page, ?lamps=N, the ad's query kept)
   5. every link to the product page carries the ad's query string and lv_src
   6. sticky bar after the reveal, hidden while the offer is on screen
   7. the dated delivery window of the trust row (same wording rules as lv.js) */
(function () {
  'use strict';
  var d = document, w = window, root = d.querySelector('[data-nn]');
  if (!root) return;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T = w.LV_T || {};
  function safe(fn) { try { fn(); } catch (e) { if (w.console) console.warn('nn', e); } }
  function each(sel, fn, r) { [].forEach.call((r || d).querySelectorAll(sel), function (el, i) { try { fn(el, i); } catch (e) { if (w.console) console.warn('nn', sel, e); } }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  var fns = [], raf = 0;
  function tick() { raf = 0; for (var i = 0; i < fns.length; i++) { try { fns[i](); } catch (e) {} } }
  function req() { if (!raf) raf = requestAnimationFrame(tick); }
  w.addEventListener('scroll', req, { passive: true });
  w.addEventListener('resize', req);

  /* 5. links to the product page: keep the ad's query string, add the set and lv_src */
  var slug = root.getAttribute('data-slug') || 'article';
  var base = root.getAttribute('data-href') || '/products/lampiero-670nm-red-night-light-portable-bedside-sleep-lamp';
  function productUrl(q) {
    var u;
    try { u = new URL(base, w.location.origin); } catch (e) { return base + '?lamps=' + q; }
    var here = new URLSearchParams(w.location.search);
    here.forEach(function (v, k) { if (k !== 'view' && k !== 'preview_theme_id' && k !== 'lamps') u.searchParams.set(k, v); });
    var pt = here.get('preview_theme_id'); if (pt) u.searchParams.set('preview_theme_id', pt);
    u.searchParams.set('lamps', String(q));
    u.searchParams.set('lv_src', 'night-notes-' + slug);
    return u.pathname + u.search;
  }
  w.nnProductUrl = productUrl;

  /* 1. the page dims */
  safe(function () {
    var crit = root.querySelector('[data-nn-crit]'), rev = root.querySelector('[data-nn-reveal]');
    var revFig = rev && rev.querySelector('.nn-fig');
    var items = crit ? [].slice.call(crit.querySelectorAll('li')) : [];
    var bar = root.querySelector('.nn-progress');
    var night = d.documentElement.hasAttribute('data-lv-night');
    /* day, dusk, night: [bg, ink, ink2, ink3, line(rgba), card] */
    var DAY = night ? [[36, 32, 31], [239, 230, 222], [212, 202, 194], [168, 156, 148], [247, 237, 227, .14], [44, 39, 37]]
                    : [[243, 242, 239], [30, 20, 18], [75, 58, 52], [124, 104, 96], [70, 40, 28, .14], [255, 253, 250]];
    var DUSK = night ? [[26, 21, 20], [242, 234, 226], [214, 204, 196], [170, 156, 147], [247, 237, 227, .13], [34, 28, 26]]
                     : [[226, 214, 207], [30, 20, 18], [70, 54, 48], [104, 86, 79], [70, 40, 28, .16], [240, 231, 225]];
    var NIGHT = [[14, 10, 9], [246, 236, 227], [220, 205, 192], [171, 153, 141], [247, 237, 227, .12], [28, 21, 19]];
    var NAMES = ['--nn-bg', '--nn-ink', '--nn-ink2', '--nn-ink3', '--nn-line', '--nn-card'];
    function mix(a, b, t) { return a.map(function (v, i) { return i < 3 ? Math.round(v + (b[i] - v) * t) : +(v + (b[i] - v) * t).toFixed(3); }); }
    function css(c) { return c.length > 3 ? 'rgba(' + c.join(',') + ')' : 'rgb(' + c.join(',') + ')'; }
    function ease(t) { return t * t * (3 - 2 * t); }
    var last = '';
    function paint() {
      var vh = w.innerHeight, a = 0, b = 0;
      if (crit) { var r = crit.getBoundingClientRect(); a = clamp((vh * 0.8 - r.top) / Math.max(1, r.height), 0, 1); }
      if (revFig) { var f = revFig.getBoundingClientRect(); b = clamp((vh * 0.9 - f.top) / Math.max(1, vh * 0.75), 0, 1); }
      var cols = [];
      for (var i = 0; i < NAMES.length; i++) {
        /* the text colour flips only while the reveal picture fills the screen, so no paragraph is ever low contrast */
        var flipT = (i >= 1 && i <= 3) ? ease(clamp((b - 0.35) / 0.3, 0, 1)) : ease(b);
        var c = b > 0 ? mix(DUSK[i], NIGHT[i], flipT) : mix(DAY[i], DUSK[i], ease(a));
        cols.push(css(c));
      }
      var key = cols.join('|');
      if (key !== last) {
        last = key;
        for (var k = 0; k < NAMES.length; k++) root.style.setProperty(NAMES[k], cols[k]);
        root.style.setProperty('--p', (0.5 * a + 0.5 * b).toFixed(3));
        if (d.body) d.body.style.setProperty('background', cols[0], 'important');
      }
      var mid = vh * 0.5;
      items.forEach(function (li) { var t = li.getBoundingClientRect().top; li.classList.toggle('is-on', t < mid); });
      if (bar) { var h = d.documentElement.scrollHeight - vh; root.style.setProperty('--nn-read', h > 0 ? clamp(w.pageYOffset / h, 0, 1).toFixed(4) : 0); }
    }
    fns.push(paint); paint();
  });

  /* 2. the light switch */
  each('[data-nn-sw]', function (el) {
    var opts = [].slice.call(el.querySelectorAll('.lv-sw__opt'));
    var imgs = [].slice.call(el.querySelectorAll('.lv-sw__media img'));
    var caps = [].slice.call(el.querySelectorAll('.lv-sw__cap'));
    var used = false;
    function set(i, focus) {
      opts.forEach(function (o, k) { o.setAttribute('aria-checked', k === i ? 'true' : 'false'); o.tabIndex = k === i ? 0 : -1; });
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      el.style.setProperty('--i', i);
      el.style.setProperty('--amb', opts[i].getAttribute('data-amb'));
      var tc = opts[i].style.getPropertyValue('--t'), cc = opts[i].style.getPropertyValue('--c');
      if (tc) el.style.setProperty('--tint', tc);
      if (cc) el.style.setProperty('--glowc', cc);
      el.setAttribute('data-state', i);
      el.setAttribute('data-red', opts[i].getAttribute('data-red') === '1' ? '1' : '0');
      caps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      if (focus) opts[i].focus();
    }
    opts.forEach(function (o, k) {
      o.addEventListener('click', function () { used = true; set(k); });
      o.addEventListener('keydown', function (e) {
        var i = opts.indexOf(o);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); used = true; set((i + 1) % opts.length, true); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); used = true; set((i + opts.length - 1) % opts.length, true); }
      });
    });
    el.addEventListener('pointerdown', function () { used = true; });
    set(0);
    if (!('IntersectionObserver' in w)) return;
    /* all three pictures are fetched before the switch is on screen, so a tap never shows a black frame */
    var warm = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { warm.disconnect(); imgs.forEach(function (im) { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); }); } }, { rootMargin: '600px 0px' });
    warm.observe(el);
    if (reduce) return;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return; io.disconnect();
      [1, 2].forEach(function (k) { setTimeout(function () { if (!used && opts[k]) set(k); }, 1500 * k); });
    }, { threshold: 0.6 });
    io.observe(el.querySelector('.lv-sw__media') || el);
  });

  /* 3. the touch arc */
  each('[data-nn-arc]', function (el) {
    var stage = el.querySelector('.nn-arc__stage'), img = el.querySelector('.nn-arc__img'), cv = el.querySelector('.nn-arc__cv');
    var svg = el.querySelector('.nn-arc__svg'), knob = el.querySelector('.nn-arc__knob'), halo = el.querySelector('.nn-arc__halo'), fill = el.querySelector('.nn-arc__fill');
    var lvls = [].slice.call(el.querySelectorAll('.nn-arc__lv'));
    if (!stage || !img || !cv || !svg) return;
    var ctx = cv.getContext('2d'); if (!ctx) return;
    var lx = parseFloat(el.getAttribute('data-lx')) / 100, ly = parseFloat(el.getAttribute('data-ly')) / 100;
    var pos = (el.getAttribute('data-pos') || '50% 50%').split(' ').map(function (s) { return parseFloat(s) / 100; });
    var v = 0.28, ready = false, touched = false, W = 0, H = 0, P = { x: 0.5, y: 0.5 }, frame = 0;
    var CX = 120, CY = 116, R = 96;
    function geom() {
      var r = stage.getBoundingClientRect(), dpr = Math.min(2, w.devicePixelRatio || 1);
      W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      /* where the lamp sits on screen: object-fit cover with the picture's own object-position */
      var iw = img.naturalWidth || 4, ih = img.naturalHeight || 5, s = Math.max(W / iw, H / ih);
      var ox = (W - iw * s) * (isNaN(pos[0]) ? 0.5 : pos[0]), oy = (H - ih * s) * (isNaN(pos[1]) ? 0.5 : pos[1]);
      P = { x: lx * iw * s + ox, y: ly * ih * s + oy };
    }
    function draw() {
      frame = 0; if (!ready) return;
      var diag = Math.sqrt(W * W + H * H), e = Math.pow(v, 0.8);
      ctx.clearRect(0, 0, W, H);
      /* the room: dark everywhere the light does not reach; the reach grows with the slider (inverse-square-like falloff) */
      /* round 2: a higher floor, so at the faint end the floor and the sink still show softly (never a black picture) */
      var reach = diag * (0.24 + 0.7 * e), dark = 0.74 - 0.46 * e;
      img.style.filter = 'brightness(' + (0.74 + 0.42 * e).toFixed(3) + ') saturate(' + (1 + 0.2 * e).toFixed(3) + ')';
      var g = ctx.createRadialGradient(P.x, P.y, 0, P.x, P.y, reach);
      g.addColorStop(0, 'rgba(6,1,2,0)');
      g.addColorStop(0.18, 'rgba(6,1,2,' + (dark * 0.12).toFixed(3) + ')');
      g.addColorStop(0.42, 'rgba(6,1,2,' + (dark * 0.45).toFixed(3) + ')');
      g.addColorStop(0.7, 'rgba(6,1,2,' + (dark * 0.8).toFixed(3) + ')');
      g.addColorStop(1, 'rgba(6,1,2,' + dark.toFixed(3) + ')');
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      /* warm red bloom from the lamp, added on top of the photo */
      ctx.globalCompositeOperation = 'lighter';
      var br = diag * (0.1 + 0.42 * e), a = 0.16 + 0.56 * e;
      var bl = ctx.createRadialGradient(P.x, P.y, 0, P.x, P.y, br);
      bl.addColorStop(0, 'rgba(255,70,60,' + (a * 0.9).toFixed(3) + ')');
      bl.addColorStop(0.3, 'rgba(230,25,40,' + (a * 0.45).toFixed(3) + ')');
      bl.addColorStop(0.65, 'rgba(160,8,24,' + (a * 0.16).toFixed(3) + ')');
      bl.addColorStop(1, 'rgba(120,0,16,0)');
      ctx.fillStyle = bl; ctx.fillRect(0, 0, W, H);
      /* the lamp itself: a hot core that never goes fully dark */
      var cr = Math.max(10, diag * (0.035 + 0.04 * e));
      var core = ctx.createRadialGradient(P.x, P.y, 0, P.x, P.y, cr);
      core.addColorStop(0, 'rgba(255,190,180,' + (0.35 + 0.45 * e).toFixed(3) + ')');
      core.addColorStop(0.5, 'rgba(255,60,70,' + (0.25 + 0.3 * e).toFixed(3) + ')');
      core.addColorStop(1, 'rgba(255,40,60,0)');
      ctx.fillStyle = core; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over';
    }
    function paintCtl() {
      var ang = Math.PI * (1 - v), x = CX + R * Math.cos(ang), y = CY - R * Math.sin(ang);
      knob.setAttribute('cx', x.toFixed(1)); knob.setAttribute('cy', y.toFixed(1));
      halo.setAttribute('cx', x.toFixed(1)); halo.setAttribute('cy', y.toFixed(1));
      halo.setAttribute('r', (16 + 12 * v).toFixed(1)); halo.style.opacity = (0.35 + 0.5 * v).toFixed(2);
      fill.setAttribute('stroke-dasharray', Math.max(0.5, v * 100).toFixed(1) + ' 100');
      svg.setAttribute('aria-valuenow', Math.round(v * 100));
      var k = v < 0.2 ? 0 : v < 0.5 ? 1 : v < 0.8 ? 2 : 3;
      lvls.forEach(function (p, i) { p.classList.toggle('is-on', i === k); });
      svg.setAttribute('aria-valuetext', lvls[k] ? lvls[k].textContent.trim() : String(Math.round(v * 100)));
    }
    function set(nv) { v = clamp(nv, 0, 1); paintCtl(); if (!frame) frame = requestAnimationFrame(draw); }
    function fromEvt(e) {
      var r = svg.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width * 240, y = (e.clientY - r.top) / r.height * 132;
      var ang = Math.atan2(Math.max(CY - y, 0), x - CX);
      return 1 - ang / Math.PI;
    }
    var drag = false;
    svg.addEventListener('pointerdown', function (e) { touched = true; drag = true; try { svg.setPointerCapture(e.pointerId); } catch (er) {} set(fromEvt(e)); e.preventDefault(); });
    svg.addEventListener('pointermove', function (e) { if (drag) set(fromEvt(e)); });
    svg.addEventListener('pointerup', function () { drag = false; });
    svg.addEventListener('pointercancel', function () { drag = false; });
    svg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { touched = true; set(v + 0.05); e.preventDefault(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { touched = true; set(v - 0.05); e.preventDefault(); }
    });
    /* dragging on the picture itself works too (horizontal only, so the page still scrolls) */
    var sx = null;
    stage.addEventListener('pointerdown', function (e) { touched = true; sx = { x: e.clientX, y: e.clientY, v: v, h: false }; });
    stage.addEventListener('pointermove', function (e) {
      if (!sx) return; var dx = e.clientX - sx.x, dy = e.clientY - sx.y;
      if (!sx.h) { if (Math.abs(dx) < 8) return; if (Math.abs(dy) > Math.abs(dx)) { sx = null; return; } sx.h = true; touched = true; }
      set(sx.v + dx / Math.max(1, W) * 1.2);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { stage.addEventListener(t, function () { sx = null; }); });
    function start() {
      if (ready) return;
      ready = true; geom(); el.classList.add('is-ready'); set(v);
      if (reduce || !('IntersectionObserver' in w)) return;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        /* one slow show: up to bright, down to faint, back to low; the first touch stops it */
        var seq = [0.88, 0.06, 0.28], i = 0;
        (function next() {
          if (touched || i >= seq.length) return;
          var from = v, to = seq[i++], t0 = performance.now(), ms = 1100 + Math.abs(to - from) * 900;
          (function f(now) { if (touched) return; var t = clamp((now - t0) / ms, 0, 1), q = t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; set(from + (to - from) * q); if (t < 1) requestAnimationFrame(f); else setTimeout(next, 350); })(t0);
        })();
      }, { threshold: 0.7 });
      io.observe(stage);
    }
    /* the light is drawn only once the picture is decoded: never a black frame on iPhone */
    function whenLoaded() { (img.decode ? img.decode() : Promise.resolve()).then(start, start); }
    if ('IntersectionObserver' in w) {
      var near = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { near.disconnect(); img.loading = 'eager'; if (img.complete && img.naturalWidth) whenLoaded(); else img.addEventListener('load', whenLoaded, { once: true }); } }, { rootMargin: '700px 0px' });
      near.observe(el);
    } else { start(); }
    paintCtl();
    w.addEventListener('resize', function () { if (ready) { geom(); draw(); } });
  });

  /* 2b. the Harvard bars fill when they come into view (lv6.js is not loaded on this layout) */
  each('.nn-stat .lv6-bars', function (b) {
    if (reduce || !('IntersectionObserver' in w)) { b.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); b.classList.add('is-in'); } }, { threshold: 0.4 });
    io.observe(b);
  });

  /* 4. the offer */
  safe(function () {
    var box = root.querySelector('[data-nn-offer]'); if (!box) return;
    var bars = [].slice.call(box.querySelectorAll('.kaching-bundles__bar'));
    var tiles = [].slice.call(box.querySelectorAll('.lv6-pick__opt'));
    var buy = box.querySelector('[data-nn-buy]'), bname = box.querySelector('[data-nn-buyname]'), bprice = box.querySelector('[data-nn-buyprice]');
    var cur = 2;
    function pick(q, focus) {
      cur = q;
      bars.forEach(function (b, i) {
        var on = i === q - 1, m = b.querySelector('.kaching-bundles__bar-main');
        b.classList.toggle('kaching-bundles__bar--selected', on);
        if (m) { m.setAttribute('aria-checked', on ? 'true' : 'false'); m.tabIndex = on ? 0 : -1; if (on && focus) m.focus(); }
      });
      tiles.forEach(function (t) { t.setAttribute('aria-pressed', parseInt(t.getAttribute('data-lv-set'), 10) === q ? 'true' : 'false'); });
      var b = bars[q - 1];
      if (b && bname) { var n = b.querySelector('[data-nn-name]'); if (n) bname.textContent = n.textContent.trim(); }
      if (b && bprice) { var p = b.querySelector('[data-nn-price]'); if (p) bprice.textContent = p.textContent.trim(); }
      if (buy) buy.setAttribute('href', productUrl(q));
    }
    bars.forEach(function (b, i) {
      b.addEventListener('click', function (e) { e.preventDefault(); pick(i + 1); });
      var m = b.querySelector('.kaching-bundles__bar-main');
      m && m.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(i + 1); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); pick(Math.min(4, i + 2), true); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); pick(Math.max(1, i), true); }
      });
    });
    tiles.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); pick(parseInt(t.getAttribute('data-lv-set'), 10) || 2); }); });
    pick(2);
    w.nnPick = pick;
    /* the sticker under the tiles gives its one small wiggle when it comes into view (lv9.css) */
    var st = box.querySelector('[data-lv9-stick]');
    if (st && 'IntersectionObserver' in w && !reduce) { var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); st.classList.add('is-in'); } }, { threshold: 0.6 }); io.observe(st); }
  });

  /* 5b. every "See the lamp" button goes to the product page with two lamps chosen */
  each('a[data-nn-go]', function (a) { a.setAttribute('href', productUrl(2)); });

  /* 6. sticky bar */
  safe(function () {
    var st = root.querySelector('[data-nn-sticky]'), rev = root.querySelector('[data-nn-reveal]'), off = root.querySelector('[data-nn-offer]');
    if (!st || !rev) return;
    var btn = st.querySelector('a');
    function check() {
      var vh = w.innerHeight, r = rev.getBoundingClientRect(), o = off ? off.getBoundingClientRect() : null;
      var after = r.top < vh * 0.25;
      var offerOn = o && o.top < vh * 0.92 && o.bottom > vh * 0.08;
      var on = after && !offerOn;
      if (on !== st.classList.contains('is-on')) {
        st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (btn) btn.tabIndex = on ? 0 : -1;
      }
    }
    fns.push(check); check();
  });

  /* 7. the dated delivery window (lv.js section 7 wording: "Thu 12 Nov and Tue 17 Nov" in English, the page language otherwise) */
  safe(function () {
    var lf = ((d.documentElement.lang || '').trim() || 'en'), lg = lf.slice(0, 2).toLowerCase();
    function day(t) {
      if (lg === 'en') return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][t.getDay()] + ' ' + t.getDate() + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][t.getMonth()];
      try { return t.toLocaleDateString(lf, { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return t.toDateString().slice(0, 10); }
    }
    function add(n) { var t = new Date(); t.setDate(t.getDate() + n); if (t.getDay() === 0) t.setDate(t.getDate() + 1); return t; }
    each('[data-lv-delivery]', function (el) {
      var min = parseInt(el.getAttribute('data-min') || '8', 10), max = parseInt(el.getAttribute('data-max') || '13', 10);
      var rg = el.querySelector('[data-lv-range]'); if (!rg) return;
      var and = (typeof T.date_and === 'string' && T.date_and) || { en: 'and', de: 'und', fr: 'et le', nl: 'en', es: 'y', it: 'e' }[lg] || 'and';
      rg.textContent = day(add(min)) + ' ' + and + ' ' + day(add(max));
    }, root);
  });

  req();
})();
